module.exports = __webpack_public_path__ + "static/media/read_face.542c4fa2.png";